var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{ref:"lblAlert",class:_vm.alertClass,style:(_vm.alertStyle),attrs:{"variant":_vm.resultType,"show":_vm.showMsg},on:{"dismissed":_vm.onAlertDismissed}},[(!_vm.isHtml)?[_vm._v(" "+_vm._s(_vm.alertMsg)+" ")]:[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertMsg)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }